import { render } from "./QrScanComponent.vue?vue&type=template&id=08d89839&scoped=true"
import script from "./QrScanComponent.vue?vue&type=script&lang=js"
export * from "./QrScanComponent.vue?vue&type=script&lang=js"

import "./QrScanComponent.vue?vue&type=style&index=0&id=08d89839&scoped=true&lang=css"

import exportComponent from "C:\\trabajo_espacio\\cuadros.ges.com\\com.ges.cuadros\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d89839"]])

export default __exports__